import fondo from "./fondo.png";

export default fondo;
